const KeyMirror = require("keymirror");

// Export types
module.exports = KeyMirror({
    SELECT_PAYMENT_OPTION: true,
    LOAD_PAYMENT_OPTIONS_BEGIN: true,
    LOAD_PAYMENT_OPTIONS_SUCCESS: true,
    LOAD_PAYMENT_OPTIONS_FAIL: true,
    LOAD_DOWNLOAD_PACKAGES_BEGIN: true,
    LOAD_DOWNLOAD_PACKAGES_SUCCESS: true,
    LOAD_DOWNLOAD_PACKAGES_FAIL: true,
    PURCHASE_OPTION_BEGIN: true,
    PURCHASE_OPTION_SUCCESS: true,
    PURCHASE_OPTION_FAIL: true,
    SELECT_DOWNLOAD_PACKAGE: true,
    START_TRANSACTION: true,
    END_TRANSACTION: true
});



// WEBPACK FOOTER //
// ./src/action-types/checkout.js